// Pause/play control for the hero "Image conveyor" (marquee) slide.
//
// The conveyor is a pure-CSS animation that runs on every viewport. Its only built-in pause is
// :hover, which doesn't exist on touch — so on mobile the motion never stops. WCAG 2.2.2 requires
// a user-operable pause for motion lasting more than 5s. This wires a small toggle button that
// flips `data-paused` on the marquee (CSS turns that into `animation-play-state: paused`).
//
// The button lives OUTSIDE the marquee's `aria-hidden="true"` subtree so it stays reachable, and we
// stop the tap from bubbling to the parent hero slide's `on:click="/select/N"` handler.

(() => {
  const toggle = (btn) => {
    const wrap = btn.closest('.hero-slide__marquee-wrap');
    const marquee = wrap && wrap.querySelector('.hero-slide__marquee');
    if (!marquee) return;

    const paused = marquee.toggleAttribute('data-paused');
    btn.setAttribute('aria-pressed', String(paused));
    btn.setAttribute('aria-label', paused ? 'Play image motion' : 'Pause image motion');
  };

  const bind = (btn) => {
    if (btn.dataset.marqueeBound) return;
    btn.dataset.marqueeBound = '1';
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggle(btn);
    });
  };

  const init = () => {
    document.querySelectorAll('[data-marquee-toggle]').forEach(bind);
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
